import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuthSession } from '@/entities/auth/api/hooks';
import { PageSpinner } from '@/shared/ui/PageSpinner';

export function RequireAuth() {
  const location = useLocation();
  const { data: session, isPending } = useAuthSession();

  if (isPending) {
    return <PageSpinner />;
  }

  if (!session?.user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return <Outlet />;
}
